export default __webpack_public_path__ + "static/hpe-72eb301fe7420d26ef52d11026a93c4d.svg";